import { Box, Paper, Table, TableContainer } from "@mui/material";

export default function CsvReadingResultTable ({
  headerRow,
  resultRows 
}) {

  return (
    <Box>
      <TableContainer component={Paper} sx={{maxWidth: "calc(100vw - 100px)", overflowX:"scroll", px: 0}}>
        <Table>
          {headerRow}
          {resultRows}
        </Table>
      </TableContainer>
    </Box>
  );
}